module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-transfer-value"
  }, [_c('label', {
    staticClass: "label-transfer-value"
  }, [_vm._v("Valor da Transferência (R$)*:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control input-transfer-value",
    attrs: {
      "type": "text",
      "name": "input-transfer-value",
      "placeholder": "0,00",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": _vm.getValue
    },
    on: {
      "input": function($event) {
        return _vm.setValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-charge-minus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.alterValue(_vm.step * -1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-charge-plus",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.alterValue(_vm.step * 1)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-32b42bf4!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/credit/transfer-credit-value.vue
// module id = 2087
// module chunks = 1